var map = {
	"./type_1.png": "b51e",
	"./type_10.png": "ca6e",
	"./type_2.png": "a837",
	"./type_3.png": "d507",
	"./type_4.png": "1160",
	"./type_5.png": "e6e8",
	"./type_6.png": "355e",
	"./type_7.png": "563b",
	"./type_8.png": "eae6",
	"./type_9.png": "499e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf9b6";